import * as React from "react";

import { AttachInfo } from "../../../../../../../Common/CandyApiClient/Types/Attachments/Attacments";
import { clamp } from "../../../../../../../Common/IntRangeUtils";
import { ProgressContainer } from "../ViewFile.styles";

import { Progress, ProgressLoading } from "./UploadFileProgress.styles";

export interface UploadFileProgressProps {
    progress: number;
}

export function UploadFileProgress(props: UploadFileProgressProps): JSX.Element {
    return (
        <ProgressContainer>
            <Progress>
                <ProgressLoading style={{ width: `${clamp(props.progress, 0, 100)}%` }} />
            </Progress>
        </ProgressContainer>
    );
}

export function getProgressValue(attachment: undefined | AttachInfo): number | undefined {
    const progress = attachment?.meta?.progress ?? 100;
    if ((typeof progress !== "number" && typeof progress !== "string") || Number(progress) >= 100) {
        return undefined;
    }
    return Number(progress);
}
